import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ButtonLink = ({ element, className, component, ...props }) => {
  const ButtonElement = component || element;

  return (
    <ButtonElement className={classnames('btn--link', className)} {...props} />
  );
};

ButtonLink.defaultProps = {
  element: 'button'
};

ButtonLink.propTypes = {
  element: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType
};

export default ButtonLink;
